import { Box, Grid } from '@material-ui/core';
import messages from 'containers/SignupPages/AuthByContratEpargnSuccess/messages';
import {
  StyledBox,
  StyledImg,
  StyledLongBody,
  StyledShortBody,
} from 'containers/SignupPages/AuthByContratEpargnSuccess/style';
import { translate } from 'helpers/intl';
import { AssuranceIcon } from 'images';
import { sanlamPink } from 'Material-UI/colors';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { ContratEpargnInfo } from 'store/contract/types';

export type ContractInfoProps = ContratEpargnInfo & {
  intl: IntlShape;
};

const ContractInfo = (props: ContractInfoProps) => {
  return (
    <Box mb={10} px={[6, 12, 18]}>
      <StyledBox padding={2} isRadiusTop>
        <Grid container alignItems="center">
          <Grid item xs={6}>
            <StyledShortBody color={sanlamPink} weight="500" MarginBottom={0}>
              {translate(messages.contratEpargn, props)}
            </StyledShortBody>
          </Grid>
          <Grid item xs={6}>
            <StyledImg src={AssuranceIcon.contractEpargn} alt="assuranceIcon" />
          </Grid>
        </Grid>
      </StyledBox>

      <StyledBox padding={2} isRadiusTop={false} isBgColor>
        <Grid container alignItems="center" spacing={2}>
          <React.Fragment>
            <Grid item xs={6}>
              <StyledShortBody weight="400">
                {translate(messages.souscripteur, props)}
              </StyledShortBody>
            </Grid>
            <Grid item xs={6}>
              <StyledLongBody weight="500">{props.name}</StyledLongBody>
            </Grid>
          </React.Fragment>
          <React.Fragment>
            <Grid item xs={6}>
              <StyledShortBody weight="400">
                {translate(messages.dateEffet, props)}
              </StyledShortBody>
            </Grid>
            <Grid item xs={6}>
              <StyledLongBody weight="500">{props.dateEffet}</StyledLongBody>
            </Grid>
          </React.Fragment>
          <React.Fragment>
            <Grid item xs={6}>
              <StyledShortBody weight="400">
                {translate(messages.numContrat, props)}
              </StyledShortBody>
            </Grid>
            <Grid item xs={6}>
              <StyledLongBody weight="500">{props.numContrat}</StyledLongBody>
            </Grid>
          </React.Fragment>
        </Grid>
      </StyledBox>
    </Box>
  );
};

export default injectIntl(ContractInfo);
